function updateStoredUtms() {
    const queryString = new URLSearchParams(window.location.search);
    const nowTimestamp = (new Date()).getTime() / 1000; // returns timestamp in seconds
    const secondsInMonth = 30 * 24 * 60 * 60;
    let savedUtms = getStoredUtms();

    for (let param of queryString) {
        const [key, val] = param;
        if (savedUtms.hasOwnProperty(key) && val.length > 0 && key.indexOf('utm_') === 0) {
            savedUtms[key] = val;
            savedUtms['expires'] = nowTimestamp + secondsInMonth;
        }
    }

    const storage = window.localStorage;
    if (storage) {
        storage.setItem('utm_values', JSON.stringify(savedUtms));
    }
}

function getStoredUtms() {
    let utms = {
        utm_source: null,
        utm_campaign: null,
        utm_medium: null,
        utm_content: null,
        expires: 0
    };

    const storage = window.localStorage;
    if (storage) {
        const storedUtms = JSON.parse(storage.getItem('utm_values') || '{}');
        const nowTimestamp = (new Date()).getTime() / 1000; // returns timestamp in seconds

        if (nowTimestamp < storedUtms.expires) {
            utms = {
                ...utms,
                ...storedUtms
            };
        } else {
            storage.setItem('utm_values', JSON.stringify(utms));
        }
    }

    return utms;
}

$(document).ready(function() {
    updateStoredUtms();

    const forms = $('form');

    const leadForms = [
        'TotemForm_GeneralEnquiryForm',         // general enquiry form
        'TotemForm_HomeDesignEnquiryForm',      // home design form
        'TotemForm_FinanceApplicationForm',     // finance form
        'TotemForm_DisplayHomeEnquiryForm',     // display homes form
        'TotemForm_DisplayTourForm',            // virtual tour form
        'TotemForm_HouseAndLandEnquiryForm',    // house and land enquiry form
        'TotemForm_ContactEnquiryForm',         // contact us enquiry form
        'TotemForm_ContactModalEnquiryForm',    // contact modal enquiry form
        'TotemForm_PromotionEnquiryForm',       // promotion enquiry form
        'TotemForm_AdvertisementEnquiryForm',   // advertisement enquiry form
    ];

    forms.each(e => {
        let currentForm = forms[e];
        validityToggleSubmit(currentForm);

        $(currentForm).on('change', function(event) {
            validityToggleSubmit(event.currentTarget, true);
        });

        // leaving as redundancy on request of douggie - it wont get anything done anyway as it doesnt match the list above
        if ($(currentForm).attr('id') === 'MemberLoginForm_LoginForm') {
            return;
        }

        if (leadForms.indexOf(currentForm.id) > -1) {
            const utmVals = getStoredUtms();
            if (utmVals.expires > 0) {
                for (let key in utmVals) {
                    const value = utmVals[key] || '';
                    if (value.length > 0 && key.indexOf('utm_') === 0) {
                        const utmInput = currentForm.querySelector(`input[name='${key}']`);
                        if (utmInput) {
                            utmInput.value = value;
                        }
                    }
                }
            }

            let hasKendo = !!$(currentForm).kendoValidator;
            let validator;

            if (hasKendo) {
                validator = $(currentForm).kendoValidator().data("kendoValidator");
            }

            $(currentForm).submit(function (event) {
                event.preventDefault();
                if (hasKendo ? validator.validate() : currentForm.checkValidity()) {
                    $.ajax({
                        url: $(this).attr('action'),
                        type: 'POST',
                        data: $(currentForm).serialize(),
                        success: (resp) => {
                            if (resp === 'ok') {
                                const kebabForm = currentForm.id.replace('TotemForm_', '').replace(/.([A-Z][a-z])/g, (match) => `${match.slice(0, 1)}-${match.slice(1)}`).toLowerCase();
                                let redirectVars = {
                                    form_type: kebabForm,
                                    form: 'success',
                                    ...getStoredUtms()
                                };

                                const heardAboutField = currentForm.querySelector('select[name="HeardAbout"]');
                                if (heardAboutField) {
                                    let heardAboutValue = heardAboutField.value.toLowerCase();

                                    if (!heardAboutValue) {
                                        heardAboutValue = 'unanswered';
                                    }

                                    redirectVars['heard_about'] = heardAboutValue.replaceAll(' ', '');
                                }

                                let queryString = [];
                                for (let key in redirectVars) {
                                    if (redirectVars[key] !== null) {
                                        const queryKey = key.replace(/^utm_/, '');
                                        queryString.push(`${encodeURIComponent(queryKey)}=${encodeURIComponent(redirectVars[key])}`);
                                    }
                                }
                                let redirect = `/thank-you?${queryString.join('&')}`;

                                if (window.location.pathname.indexOf('/bunbury-and-south-west') === 0) {
                                    redirect = `/bunbury-and-south-west${redirect}`;
                                }

                                window.location.href = redirect;
                            } else {
                                $('.Actions.form-actions.actions').html(() => {
                                    return '<div class="success"><p>An error has occurred, please try again shortly.</p></div>';
                                });
                            }
                        },
                        error: () => {
                            $('.Actions.form-actions.actions').html(() => {
                                return '<div class="success"><p>An error has occurred, please try again shortly.</p></div>';
                            });
                        }
                    });
                }
            });
        }
    });

    // packages page form
    const packageAttributes = document.getElementById('packageAttributes');
    if (packageAttributes) {
        const parentForm = packageAttributes.parentElement.querySelector('form');
        const mappings = {
            HalperUid: 'data-halper-uid',
            HalperTitle: 'data-halper-title',
            SuburbTitle: 'data-halper-suburb'
        };

        for (let key in mappings) {
            const formInput = parentForm.querySelector(`input[name="${key}"]`);
            if (formInput) {
                formInput.value = packageAttributes.getAttribute(mappings[key]);
            }
        }
    }
});

function validityToggleSubmit(form, reportValidity = false) {
    if ($(form)[0].checkValidity()) {
        $(form)
            .find('button[type="submit"]')
            .removeAttr('disabled');
    } else {
        $(form)
            .find('button[type="submit"]')
            .attr('disabled', 'disabled');
        if (reportValidity) {
            $(form)[0].reportValidity();
        }
    }
}
